module.exports = __webpack_public_path__ + "img/kuangjiao_xc8.d9ed5fb3.jpg";